import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { currencySymbol } from '@utils/currency';
import { formatMoneyValue } from '@utils/moneyFormatting';
import { Box, Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import type { CurrencyBalance } from './depositInternalTransferCurrencies';

export type DepositInternalTransferCurrencyBalanceDisplayProp = {
  amountCents?: number;
  currencyBalance: CurrencyBalance;
};

export const DepositInternalTransferCurrencyBalanceDisplay = ({
  amountCents,
  currencyBalance,
}: DepositInternalTransferCurrencyBalanceDisplayProp) => {
  const { t } = useTranslation('workflowCompletions');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        mb: 2,
        mt: 0.5,
      }}
      data-testid='currency-balance-display'
    >
      <InfoOutlinedIcon
        sx={{
          fontSize: 16,
          color:
            (amountCents || 0) > currencyBalance.availableCents
              ? 'error.main'
              : 'info.main',
        }}
      />
      <Typography variant='labelLarge' color='textSecondary'>
        {t('transfer:availableCurrencyBalance', {
          currency: currencyBalance.currency,
        })}
      </Typography>
      <Typography
        variant='bodyLarge'
        color={
          (amountCents || 0) > currencyBalance.availableCents
            ? 'error'
            : 'textPrimary'
        }
        sx={{ fontWeight: 600 }}
      >
        {formatMoneyValue(
          currencyBalance.availableCents,
          currencySymbol[
            currencyBalance.currency as keyof typeof currencySymbol
          ] || '$',
        )}
      </Typography>
    </Box>
  );
};
